import { ValueOfKey } from '../../utils-types';
import { BillingPeriodType } from '../../payment/constants/billingPeriodType';

export const SETUP_STATUS = {
  NEED_SETUP: 'NEED_SETUP',
  COMPLETED: 'COMPLETED',
} as const;

type SetupStatus = ValueOfKey<typeof SETUP_STATUS>;

export type ScanIqCustomer = {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string;
  dateOfBirth: string | null;
  gender: string | null;
  height: number | null;
  entityId: number;
  setupStatus: SetupStatus;
  inbodyId: string;
  activeSubscription: ScanIqCustomerSubscription | null;
};

type ScanIqCustomerSubscription = {
  billingPeriodType: BillingPeriodType;
  id: number;
  name: string;
};
